interface DiffData {
  origin: string;
  add: number[];
}

export function strArrDiff() {
  return (p: DiffData, c: number[] | null): DiffData => {
    if (!c) {
      // 重置
      return {origin: '', add: []};
    }
    const cStr = c.sort().join(',');
    if (p.origin === cStr) {
      return {origin: p.origin, add: []};
    }
    const prev = p.origin.split(',');
    return {origin: cStr, add: c.filter((o) => !prev.includes(String(o)))};
  };
}
